import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';


@Pipe({
  name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {

  transform(value: any, format: string = 'mediumDate', locale: string = 'en'): string | null {
    return value ? formatDate(value, format, locale) : null;
  }

}